import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import { setErrors } from '../common/errorsSlice'

import { CustomSummaryRequest, CustomSummaryResponse, DailySummaryRequest, DailySummaryResponse } from '../../types/dataSummary'
import { getCustomSummary, getDailySummary } from '../../apis/dataSummary'

interface State {
  isLoading: boolean
  dailySummary: DailySummaryResponse | undefined
  customSummary: CustomSummaryResponse | undefined
}

const initialState: Partial<State> = {
  isLoading: true,
  dailySummary: undefined,
  customSummary: undefined,
}

const summarySlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    buildDailySummary: (state, action: PayloadAction<DailySummaryResponse>) => {
      state.isLoading = false
      state.dailySummary = action.payload
      return state
    },
    buildCustomSummary: (state, action: PayloadAction<CustomSummaryResponse>) => {
      state.isLoading = false
      state.customSummary = action.payload
      return state
    },
    resetState: (state) => {
      // eslint-disable-next-line no-param-reassign
      state = initialState
      return state
    },
  },
})

export const {
  requestStart,
  buildDailySummary,
  buildCustomSummary,
  resetState,
} = summarySlice.actions

export const summaryReducer = summarySlice.reducer

export const fetchDailySummary = (
  param: DailySummaryRequest,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getDailySummary(param)
    .then((result: DailySummaryResponse) => {
      dispatch(buildDailySummary(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchCustomSummary = (
  param: CustomSummaryRequest,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getCustomSummary(param)
    .then((result: CustomSummaryResponse) => {
      dispatch(buildCustomSummary(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}
